// extracted by mini-css-extract-plugin
export default {"spinner":"decommissioning__spinner","form":"decommissioning__form","errors-alert":"decommissioning__errors-alert","submit-button":"decommissioning__submit-button"};